import { render } from "./PartDesignList.vue?vue&type=template&id=39d1ac78"
import script from "./PartDesignList.vue?vue&type=script&lang=js"
export * from "./PartDesignList.vue?vue&type=script&lang=js"
script.render = render

export default script